import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  VisualInspectionDto,
  VisualInspectionReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import VisualInspectionInline from "./VisualInspectionInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: VisualInspectionDto | VisualInspectionReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function VisualInspectionLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.VisualInspectionRead]}
      to={ROUTE_PATH.VISUAL_INSPECTION_VIEW(entity?.id || entityId || "")}
      content={<VisualInspectionInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
